import RecursiveContent from "./RecursiveContent";

export default RecursiveContent;
